import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  githubAuthApiRef,
  identityApiRef,
  storageApiRef,
} from '@backstage/core-plugin-api';
import {
  ScmAuth,
  ScmIntegrationsApi,
  scmAuthApiRef,
  scmIntegrationsApiRef,
} from '@backstage/integration-react';
import { VisitsStorageApi, visitsApiRef } from '@backstage/plugin-home';
import { techRadarApiRef } from '@backstage-community/plugin-tech-radar';
import { TechRadarClient } from './lib/TechRadarClient';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: visitsApiRef,
    deps: {
      storageApi: storageApiRef,
      identityApi: identityApiRef,
    },
    factory: ({ storageApi, identityApi }) =>
      VisitsStorageApi.create({ storageApi, identityApi }),
  }),
  createApiFactory({
    api: techRadarApiRef,
    deps: {},
    factory: () => new TechRadarClient(),
  }),
  createApiFactory({
    api: scmAuthApiRef,
    deps: {
      githubAuthApi: githubAuthApiRef,
    },
    factory: ({ githubAuthApi }) => ScmAuth.forGithub(githubAuthApi),
  }),
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
];
